var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipConnectModuleColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIP Connect Module copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3124 8.83988C25.5044 6.99988 22.5524 6.97188 20.7164 8.77588C18.8804 10.5799 18.8564 13.5319 20.6604 15.3719C22.4644 17.2119 25.4204 17.2399 27.2564 15.4359C29.0924 13.6319 29.1164 10.6799 27.3124 8.83988ZM25.0684 14.0519C24.3964 14.4399 23.5324 14.4279 22.8684 14.0279C21.5564 13.2359 21.4124 11.5079 22.4244 10.5119C23.3004 9.65188 24.7084 9.66388 25.5724 10.5439C26.5684 11.5599 26.3964 13.2879 25.0684 14.0519Z",
    fill: "#5A03EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1521 18.8121C19.1961 20.8921 19.1681 24.2321 17.0881 26.2721C15.0081 28.3121 11.6681 28.2801 9.62407 26.2001C7.58007 24.1201 7.60807 20.7801 9.68807 18.7361C11.7641 16.6961 15.1081 16.7281 17.1481 18.8081",
    fill: "#5A03EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0799 15.4561L12.3999 25.0401L11.2559 23.9241L20.9319 14.3401L22.0799 15.4561Z",
    fill: "#5A03EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipConnectModuleColoured);
export default __webpack_public_path__ + "static/media/HIP Connect Module Coloured.285498908336993666256960e1f80325.svg";
export { ForwardRef as ReactComponent };